import ProgressBar from './ProgressBar';

export default ProgressBar;



// WEBPACK FOOTER //
// ./src/components/progressbar/index.js